//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "directionButton",
  props: [
    "onClick",
    "leftValue",
    "rightValue",
    "upValue",
    "downValue",
    "confirmValue"
  ],
  methods: {
    click: function(val) {
      this.onClick(val);
    }
  },
  data() {
    return {};
  }
};



// WEBPACK FOOTER //
// ./src/items/directionButton.vue